import React, { useMemo } from 'react'
import { Card, Divider } from 'semantic-ui-react'
import styled from 'styled-components'
import { FlexRow, AppRemoveButtonPopup, AppEditButton, FlexBox, AppTable } from 'components'
import { useTabletAndBelowMediaQuery } from 'layout'

const SectionContainer = styled.div`
    .card {
        width: 100% !important;
    }
`

const SectionCard = ({
    item,
    i,
    edit,
    remove,
    onDragStart,
    onDragOver,
    onDragEnd,
    onDrop,
    draggingIndex,
    showNumbers = false,
}) => {
    return (
        <Card
            key={item.SectionId}
            draggable
            className={`draggable ${draggingIndex === i ? 'dragging' : ''}`}
            onDragStart={e => onDragStart(e, i)}
            onDragOver={e => onDragOver(e)}
            onDragEnd={onDragEnd}
            onTouchStart={e => onDragStart(e, i)}
            onTouchMove={onDragOver}
            onTouchEnd={onDragEnd}
            onTouchCancel={onDragEnd}
            onDrop={e => {
                onDrop(e, i);
            }}
        >
            <Card.Content>
                <Card.Header>
                    <FlexRow>
                        <div className="col">
                            <p className="pe-2 col">
                                {showNumbers && (
                                    <strong className="me-2">
                                        {(typeof i === 'number' ? i : 0) + 1}.
                                    </strong>
                                )}
                                {item.SectionName}
                            </p>
                        </div>
                        <div className="col-4 justify-content-end d-flex">
                            {/* <AppIconButton icon={<List size={15} />} text="" onClick={() => edit(item)} /> */}
                            <AppEditButton icon="edit" onClick={() => edit(item)} />
                            <AppRemoveButtonPopup icon="trash" onClick={() => remove(item)} />
                        </div>
                    </FlexRow>
                </Card.Header>
                <Divider className="mt-2" />
                <Card.Meta>{item.Questions.length} Questions</Card.Meta>
            </Card.Content>
        </Card>
    )
}

export const SectionList = ({
    sectionList,
    remove,
    edit,
    onDragCompleted,
    showNumbers = false,
}) => {
    const isMobile = useTabletAndBelowMediaQuery()
    const numberedData = useMemo(
        () => sectionList.map((s, i) => ({ ...s, __rowIndex: i })),
        [sectionList],
    )

    const columns = useMemo(
        () => [
            {
                title: 'Section Name',
                render: item => (
                    <>
                        {showNumbers && (
                            <strong className="me-2">
                                {(item.__rowIndex || 0) + 1}.
                            </strong>
                        )}
                        {item.SectionName}
                    </>
                ),
            },
            {
                title: 'Questions',
                render: (item) => <>{item.Questions.length}</>,
            },
            {
                title: 'Actions',
                render: (item) => (
                    <FlexBox className="justify-content-center">
                        <AppEditButton onClick={() => edit(item)} />
                        <AppRemoveButtonPopup onConfirm={() => remove(item)} />
                    </FlexBox>
                ),
            },
        ],
        [sectionList, isMobile, showNumbers]);

    const handleDragCompleted = list => {
        if (!onDragCompleted) return
        const cleaned = list.map(({ __rowIndex, ...rest }) => rest)
        onDragCompleted(cleaned)
    }

    return (
        <SectionContainer className="mt-3">
            <AppTable
                data={numberedData}
                columns={columns}
                draggable
                onDragCompleted={handleDragCompleted}
                mobileCard={
                    <SectionCard
                        remove={remove}
                        edit={edit}
                        showNumbers={showNumbers}
                    />
                }
                hidePagination
            />
        </SectionContainer>
    )
}
